export default {
  medium: '@media only screen and (max-width: 820px)',
  small: '@media only screen and (max-width: 320px)',
} as const;
